// Legacy /documents* + /docs URL-normalizing redirect (2026-08-06 per Nika
// "rename Documents (/documents) to Notes (/notes)"). Mirrors the /tickets →
// /tasks pattern: ONE redirect def registered under every legacy key routes
// to the canonical form, so the address bar always shows /notes and the app
// maintains a single route family. Target derivation is data-driven via
// canonicalRoutePath (shared/functions/workspacePrefix.js) — the same map
// the navbar/header active-matchers use — so the redirect can never disagree
// with them. Query + hash ride along (?id= deep links, #note=/#kb= editor
// permalinks). Same replace-not-push convention as tasksRedirect: el.router
// goes through the MWT wrapper, which re-emits the /w/<org> prefix for the
// stripped canonical target.
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).
import _wsShared from '@symbo-ls/workspace-shared'
import { shellStripWorkspacePrefix } from '../functions/shellSharedDelegates.js'
// Deferred to call time — an eager module-scope destructure of the barrel's
// default crashes the shell boot inside the shared-barrel init cycle.
const shellCanonicalRoutePath = (...args) => _wsShared.functions.canonicalRoutePath(...args)

export const notesRedirect = {
  tag: 'main',
  id: 'main-content',
  extends: 'AppPage',
  metadata: (el) => ({ title: el.call('pageTitle', 'workspace.redirect.page.title') }),

  AppSidebar: null,

  AppMain: {
    flow: 'y',
    align: 'center center',
    padding: 'C',
    onCreate: (el) => {
      if (typeof window === 'undefined') return
      const stripped = shellStripWorkspacePrefix(window.location.pathname || '/')
      const canonical = shellCanonicalRoutePath(stripped)
      const target = canonical + (window.location.search || '') + (window.location.hash || '')
      try {
        el.router(target, el.getRoot())
      } catch (err) {
        window.location.replace(target)
      }
    },
    Notice: {
      tag: 'span',
      fontSize: 'Y',
      color: 'caption',
      text: '{{ workspace.redirect.openingNotes | polyglot }}'
    }
  }
}
